<script setup>
import { toRefs } from "vue";
import BreadCrumb from "@/components/shared/BreadCrumb";
import CloseIcon from "@/components/svg-icons/CloseIcon.vue";
import { Dialog, DialogTitle, DialogPanel } from "@headlessui/vue";
import TableuData from "./TableuData.vue";
import BookingsData from "./BookingsData.vue";

const props = defineProps({
  modalIsOpen: {
    type: Boolean,
    default: false,
  },
  tableauInformation: {
    type: Object,
    default: () => ({
      columns: [],
      data: [],
      extra: {},
    }),
  },
  bedId: {
    type: String,
    default: "",
  },
});

const { modalIsOpen, tableauInformation, bedId } = toRefs(props);

const emit = defineEmits(["closeModal"]);
</script>

<template>
  <div class="bg-blue-100 text-sm text-indigo-base">
    <div class="mx-5">
      <div class="flex flex-col items-baseline justify-between">
        <BreadCrumb class="mt-10" />
        <div>
          <Dialog
            :open="modalIsOpen"
            class="w-screen fixed inset-0 z-50 overflow-auto bg-white py-6 sm:bg-transparent sm:p-12"
            @close-modal="emit('closeModal')"
            @click.self="emit('closeModal')"
          >
            <div
              class="relative z-50 mx-auto max-w-8xl bg-white px-6 sm:rounded-lg sm:px-16 sm:py-20 sm:shadow md:px-24"
            >
              <div
                class="absolute right-3r xs:top-1r sm:top-3r md:top-3r lg:top-3r"
              >
                <button
                  class="flex h-6 w-6 items-center justify-center"
                  @click="emit('closeModal')"
                >
                  <CloseIcon size="28" stroke="#007f80" stroke-width="1.75" />
                </button>
              </div>
              <DialogPanel>
                <DialogTitle
                  class="mb-12 mt-6 flex justify-center text-center text-xl leading-tight sm:text-2xl md:text-3xl"
                >
                  Room Assignment
                </DialogTitle>
                <div
                  class="w-full flex-col justify-between pb-20 overflow-x-hidden"
                >
                  <TableuData :tableau-information="tableauInformation" />
                  <BookingsData
                    :bed-id="bedId"
                    :tableau-information="tableauInformation"
                    @close-modal="emit('closeModal')"
                  />
                </div>
              </DialogPanel>
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  </div>
</template>
